import { Separator } from "@/components/ui/separator";
import { formatPrice } from "@/lib/utils";
import {
  calculateShippingCost,
  FREE_SHIPPING_THRESHOLD,
} from "../constants/shipping-constants";

interface CartSummaryProps {
  subtotal: number;
  total: number;
  shipping?: number;
  discount?: number;
}

export function CartSummary({
  subtotal,
  total,
  shipping,
  discount = 0,
}: CartSummaryProps) {
  const actualShipping =
    shipping !== undefined ? shipping : calculateShippingCost(subtotal);

  return (
    <div className="space-y-3">
      <div className="flex justify-between items-center text-sm">
        <span className="text-muted-foreground">Subtotal</span>
        <span className="font-medium">{formatPrice(subtotal)}</span>
      </div>

      {discount > 0 && (
        <div className="flex justify-between items-center text-sm">
          <span className="text-muted-foreground">Descuento</span>
          <span className="font-medium text-green-600">
            -{formatPrice(discount)}
          </span>
        </div>
      )}

      {actualShipping > 0 ? (
        <div className="flex justify-between items-center text-sm">
          <span className="text-muted-foreground">Envío</span>
          <span className="font-medium">{formatPrice(actualShipping)}</span>
        </div>
      ) : (
        <div className="flex justify-between items-center text-sm">
          <span className="text-muted-foreground">Envío</span>
          <span className="font-medium text-green-600">Gratis</span>
        </div>
      )}

      <Separator />

      <div className="flex justify-between items-center">
        <span className="font-semibold text-base">Total</span>
        <span className="font-bold text-primary text-xl">
          {formatPrice(total + actualShipping - discount)}
        </span>
      </div>

      {subtotal < FREE_SHIPPING_THRESHOLD && (
        <p className="text-muted-foreground text-xs">
          Agrega {formatPrice(FREE_SHIPPING_THRESHOLD - subtotal)} más para
          envío gratis
        </p>
      )}
    </div>
  );
}
